"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.braintreeOnValidateMerchantApple = void 0;
const checkout_frontend_library_1 = require("@bold-commerce/checkout-frontend-library");
const manageBraintreeState_1 = require("../manageBraintreeState");
const actions_1 = require("../../actions");
const types_1 = require("../../types");
function braintreeOnValidateMerchantApple(event) {
    return __awaiter(this, void 0, void 0, function* () {
        const appleInstance = (0, manageBraintreeState_1.getBraintreeApplePayInstanceChecked)();
        const applePaySession = (0, manageBraintreeState_1.getBraintreeApplePaySessionChecked)();
        const { shop_name: shopName } = (0, checkout_frontend_library_1.getOrderInitialData)();
        try {
            const merchantSession = yield appleInstance.performValidation({
                validationURL: event.validationURL,
                displayName: shopName
            });
            applePaySession.completeMerchantValidation(merchantSession);
        }
        catch (e) {
            (0, actions_1.displayError)('There was an error while loading Apple Pay.', 'generic', 'unknown_error');
            applePaySession.abort();
            if (e instanceof Error) {
                throw new types_1.ApplePayValidateMerchantError(e.message);
            }
            throw new types_1.ApplePayValidateMerchantError(`Error validating merchant: ${e}`);
        }
    });
}
exports.braintreeOnValidateMerchantApple = braintreeOnValidateMerchantApple;
